/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export const SET_DEFAULT_SETTINGS_MENU_STATE = 'SET_DEFAULT_SETTINGS_MENU_STATE';
export const SET_DEFAULT_SETTINGS_SUBMENU_STATE = 'SET_DEFAULT_SETTINGS_SUBMENU_STATE';
export const SET_SETTINGS_ENTERED_NUMBER = 'SET_SETTINGS_ENTERED_NUMBER';
export const SET_SETTINGS_FOCUSED_ITEM_INDEX = 'SET_SETTINGS_FOCUSED_ITEM_INDEX';
export const SET_SETTINGS_HIGHLIGHT_MENU = 'SET_SETTINGS_HIGHLIGHT_MENU';
export const SET_SETTINGS_HIGHLIGHT_SUBMENU = 'SET_SETTINGS_HIGHLIGHT_SUBMENU';
export const SET_SETTINGS_MENU_FOCUS = 'SET_SETTINGS_MENU_FOCUS';
export const SET_SETTINGS_MENU_HIGHLIGHT_ITEM = 'SET_SETTINGS_MENU_HIGHLIGHT_ITEM';
export const SET_SETTINGS_MENU_SELECTED_ITEM = 'SET_SETTINGS_MENU_SELECTED_ITEM';
export const SET_SETTINGS_MENU_VERTICAL_POSITION = 'SET_SETTINGS_MENU_VERTICAL_POSITION';
export const SET_SETTINGS_NEXT_HIGHLIGHT_POSITION = 'SET_SETTINGS_NEXT_HIGHLIGHT_POSITION';
export const SET_SETTINGS_SUBMENU_FOCUS = 'SET_SETTINGS_SUBMENU_FOCUS';
export const SET_SETTINGS_SUBMENU_SELECTED_ITEM = 'SET_SETTINGS_SUBMENU_SELECTED_ITEM';
export const SET_SETTINGS_SUBMENU_VERTICAL_POSITION = 'SET_SETTINGS_SUBMENU_VERTICAL_POSITION';
